var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import orderBy from "lodash/orderBy";
import { BookModelCollection } from "../BookModelCollection";
var AppointmentModelCollection = /** @class */ (function (_super) {
    __extends(AppointmentModelCollection, _super);
    function AppointmentModelCollection() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AppointmentModelCollection.prototype.futureAppointments = function () {
        var now = new Date();
        return this.filter(function (appointment) { return appointment.get('from') >= now; });
    };
    AppointmentModelCollection.prototype.findNextAppointment = function (placement) {
        var _a;
        var nextAppointment = (_a = orderBy(this.futureAppointments().all(), ["from.date"], ["asc"])) === null || _a === void 0 ? void 0 : _a[0];
        if (!nextAppointment)
            return null;
        var timespan = nextAppointment.getTimespans().first();
        return {
            at: nextAppointment.getFromToAuto(placement),
            title: timespan.getAsTitle([], {
                placement: placement,
                hidePrice: true,
                hideDateTime: true,
                hidePlacesLeft: true,
            }),
        };
    };
    return AppointmentModelCollection;
}(BookModelCollection));
export { AppointmentModelCollection };
